export default {
  "/set": "IF-icon-shezhiicon-dianji",
  "/collection": "IF-icon-quanqiushoukuanicon-dianji",
  "/contact": "IF-icon-lianxirenicon-dianji1",
  "/swapForex": "IF-icon-duobihuanhuiicon--changtai",
  "/payment": "IF-icon-qqfk-dis"
};
